// extracted by mini-css-extract-plugin
export default {"footer":"mhwkk","iconsBlock":"m_dEs","icons":"eJnqV","iconHabr":"p6UMz","iconX5":"IdGOs","businessUnitIcon":"kovar"};